import { String } from "./utilities";

class LocalStorageHelper{
    public static set<T>(key: string, value: T){
        localStorage.setItem(key, JSON.stringify(value));
    }
    public static get<T>(key: string): T{
        var item = localStorage.getItem(key);
        if(!String.IsNullOrWhiteSpace(item)){
            return JSON.parse(item) as T;
        }
        return null;
    }
    public static remove(key:string){
        var item = localStorage.getItem(key);
        if(!String.IsNullOrWhiteSpace(item)){
            localStorage.removeItem(key);
        }
    }
}

export default LocalStorageHelper;